/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {ForYouLanding} from "../../for_you/views/ForYouLanding";
const route = [{bundlerEntry: "weFindForYou", path: rpAppPath.weFindForYou.base, component: ForYouLanding}];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {ForYouLanding} from "../../for_you/views/ForYouLanding";
const route = [{bundlerEntry: "weFindForYou", path: rpAppPath.weFindForYou.base, component: ForYouLanding}];

(function () {
    rpClient(route);
})();
